module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-920.1f8d704b.jpg";